import { getFlightClass } from 'checkout/store/selectors/view';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  businessFlightsSelector,
  economyFlightsSelector,
  flightsCountSelector,
  visibleFlightsCountSelector,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';

import { setVisibleFlights } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/slice';

import FlightsResults from './FlightsResults';

const mapStateToProps = (state) => ({
  economyFlights: economyFlightsSelector(state),
  businessFlights: businessFlightsSelector(state),
  flightCount: flightsCountSelector(state),
  flightClass: getFlightClass(state),
  visibleFlights: visibleFlightsCountSelector(state),
});

const mapDispatchToProps = {
  setVisibleFlights,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(FlightsResults);
